<mat-card *ngIf="pbo && pos" [ngClass]="changed ? 'order-changed' : ''">
  <mat-card-content>
    <div class="ps-grid-3-col">
      <div>
        <h2 class="mat-h2">
          <img class="mat-icon" src="{{ pos.ICON_URL }}" />
          {{ pos.NAME }}
        </h2>
        <div>{{ pos.SNR }}</div>
        <div>{{ pos.PROJEKT_NAME }} {{ pos.PROJEKT_DESCRIPTION }}</div>
        <div *ngIf="isInternal()">
          Werkzeugausführung: {{ pos.AUSFUEHRUNG }}
        </div>
      </div>
      <div>
        <mat-icon>schedule</mat-icon>
        {{ pos.TERMINA | date }}
      </div>
      <div class="booking-tag" *ngIf="pos.IS_OMITTED">
        {{ 'orders.positions.omitted' | translate }}
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions align="end">
    <button
      mat-button
      color="primary"
      matTooltip="WZA Dokumente"
      routerLink="/orders/{{ pbo.OBJECT_ID }}/{{ pos.OBJECT_ID }}/etadocuments">
      <mat-icon>picture_as_pdf</mat-icon>
    </button>
    <button
      *ngIf="suppliersService.hasPseChangeDocument(pos)"
      mat-button
      color="primary"
      matTooltip="Änderungsvermerk"
      (click)="openChangedDialog()">
      <mat-icon>task_alt</mat-icon>
    </button>
  </mat-card-actions>
</mat-card>
